export const getDomain = () => {
  if (process.env.NODE_ENV != "production") {
    return `https://apidesk.levelpropiedades.cl`;
  }
  return `https://apidesk.levelpropiedades.cl`;
};

export const postCodigoEnvia = () => {
  if (process.env.NODE_ENV != "production") {
    return `/api/usuario/codigo/envia`;
  }
  return `/api/usuario/codigo/envia`;
};

export const postCodigoValida = () => {
  if (process.env.NODE_ENV != "production") {
    return `/api/usuario/codigo/valida`;
  }
  return `/api/usuario/codigo/valida`;
};

export const postUsuarioPasswordUpdate = () => {
  if (process.env.NODE_ENV != "production") {
    return `/api/usuario/password/update`;
  }
  return `/api/usuario/password/update`;
};

export default getDomain;
